import { useRolesColumns } from "PFApp/workflow/parts/roles/use_roles_columns";
import { TableColumn } from "PFCore/types";
import { useMemo } from "react";

const AVAILABLE_ADDITIONAL_COLUMNS = [
  "id",
  "status",
  "workflow_state",
  "vacancies",
  "created_at",
  "principal_owner",
  "source_role",
  "target_roles",
  "activity_tag"
];

const NO_BLOCKED_PROPERTIES: string[] = [];

export const useAvailableManageRolesAdditionalColumns = (): TableColumn[] => {
  const { availableWithCustomTypesColumns } = useRolesColumns(NO_BLOCKED_PROPERTIES);

  return useMemo(
    () => availableWithCustomTypesColumns.filter(({ name }) => AVAILABLE_ADDITIONAL_COLUMNS.includes(name)),
    [availableWithCustomTypesColumns]
  );
};
